module.exports = __webpack_public_path__ + "img/Monte_Kope_67.5fad78c8.jpg";